import moment from 'moment';
export var API_URL = '/api';

// This is used for DateRangePicker's default date 'Last 7 days'
export var DEFAULT_DATE_RANGE = {
  START: moment().subtract(6, 'days'),
  END: moment()
};